import { mapGetters } from "vuex";
import * as DESTINIES_GETTERS from "../../store/destinies/getter-types";
import isMobileMixin from "../../utils/mixins/isMobile";
import prependCustomIcons from "../../utils/mixins/prependCustomIcons";

export default {
  mixins: [isMobileMixin, prependCustomIcons],
  data: () => ({
    showDialog: false
  }),
  computed: {
    ...mapGetters({
      locations: DESTINIES_GETTERS.GET_LOCATIONS,
      selectedLocation: DESTINIES_GETTERS.GET_SELECTED_DESTINY
    }),
    isMobileMixin() {
      return this.isMobile();
    },
    bannerBackground() {
      return this.selectedLocation.landing_main_image
        ? `/storage/${this.selectedLocation.landing_main_image}`
        : "/img/destinies/landing/roma.jpg";
    }
  },
  methods: {
    goHome() {
      this.$router.push("/").catch(() => {});
    }
  }
};
